import {Card, Grid, Icon, Stack, Tabs} from '@mui/material';
import Tab from '@mui/material/Tab';
import theme from 'src/styles/theme';
import LabelInput from '@components/label/LabelInput';
import DateTimeUtils, {DEFAULT_DATE_FORMAT} from '@shared/utils/DateTimeUtils';
import ProfileCover from 'src/sections/user/profile-cover';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {_mock, _userAbout} from 'src/_mock';
import Iconify from 'src/minimal-components/iconify';
import {useCallback, useEffect, useState} from 'react';
import {SubHeading} from './ProfileStyle';
import LabelValueInput from '@components/label-value/LabelValueInput';

const ProfilePage = (props: any): React.ReactElement => {
  const renderPersonalInfo = (): React.ReactElement => {
    return (
      <Stack
        sx={{
          ml: {md: 2},
          mb: 4,
          textAlign: {xs: 'center', md: 'unset'},
          flexDirection: 'row',
          gap: 2
        }}>
        <Stack direction="row">
          <Icon
            color="primary"
            sx={{
              mt: 0.2
            }}>
            <Iconify icon="material-symbols:person" />
          </Icon>
          <LabelInput
            label={props?.values?.[props?.labels?.fields?.[2]?.data_column]}
            style={{justifyContent: 'center', marginTop: 1}}
            align={'center'}
            variant={'subtitle2'}
            labelColor={theme.palette.common.white}
          />
        </Stack>

        <Stack direction="row">
          <Icon color="primary">
            <Iconify icon="mingcute:birthday-2-fill" />
          </Icon>
          <LabelInput
            label={DateTimeUtils.format(
              props?.values?.[props?.labels?.fields?.[3]?.data_column],
              DEFAULT_DATE_FORMAT
            )}
            style={{justifyContent: 'center', marginTop: 1}}
            align={'center'}
            variant={'subtitle2'}
            labelColor={theme.palette.common.white}
          />
        </Stack>
      </Stack>
    );
  };

  const renderProfileInfo = (): React.ReactElement => {
    return (
      <Grid
        sx={{
          mb: 2
        }}>
        <Card sx={{p: 3, boxShadow: 5, borderRadius: '8px'}}>
          {props.labels?.sub_sections?.map?.(
            (mainItem: any, mainIndex: number) => {
              return (
                <Grid key={`${mainItem?.name}-${mainIndex}`}>
                  <SubHeading
                    style={{
                      padding: '0.4em 0 0.5em 0'
                    }}>
                    <Grid
                      container
                      gap={1}
                      sx={{
                        marginTop: mainItem.heading === 'Address' ? 0 : 2
                      }}>
                      {mainItem.heading === 'Address' ? (
                        <Icon color="primary">
                          <Iconify
                            icon="mingcute:location-fill"
                            width={24}
                            sx={{
                              mb: 3
                            }}
                          />
                        </Icon>
                      ) : (
                        <Icon color="primary">
                          <Iconify icon="solar:phone-bold" width={24} />
                        </Icon>
                      )}
                      <LabelInput
                        label={mainItem.heading}
                        align={'left'}
                        variant={'body1'}
                        fontWeight={600}
                        labelColor={theme.palette.common.black}
                      />
                    </Grid>
                  </SubHeading>

                  <SubHeading />
                  <Grid container spacing={2} alignItems="center">
                    {mainItem.fields?.map?.((item: any, index: number) => {
                      return (
                        <Grid
                          sx={{
                            paddingTop: '1em !important',
                            overflowWrap: 'break-word'
                          }}
                          item
                          xs={12}
                          md={12 / mainItem?.columns}
                          key={`${item.data_column}-${index}`}>
                          <LabelValueInput
                            label={item.label}
                            value={props?.values?.[item?.data_column] || '-'}
                            align={'left'}
                            variant={'subtitle2'}
                            spacing={2}
                            labelWidth="35%"
                            valueWidth="65%"
                            style={{fontWeight: item.label ? 400 : 600}}
                            labelColor={theme.palette.grey[500]}
                            valueColor={theme.palette.common.black}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
              );
            }
          )}
        </Card>
      </Grid>
    );
  };

  const [currentTab, setCurrentTab] = useState('legacyMRNs');
  const [firstNames, setFirstname] = useState('');
  const [middleNames, setMiddleName] = useState('');
  const [lastNames, setLastName] = useState('');
  const handleChangeTab = useCallback(
    (event: React.SyntheticEvent, newValue: string) => {
      setCurrentTab(newValue);
    },
    []
  );
  useEffect(() => {
    if (props?.values?.FirstName && props?.values?.FirstName !== 'null') {
      setFirstname(props?.values?.FirstName);
    }
    if (props?.values?.MiddleName && props?.values?.MiddleName !== 'null') {
      setMiddleName(props?.values?.MiddleName);
    }
    if (props?.values?.LastName && props?.values?.LastName !== 'null') {
      setLastName(props?.values?.LastName);
    }
  }, []);
  // console.log('naems', firstNames, middleNames, lastNames);
  const TABS = [
    {
      value: 'legacyMRNs',
      label: 'Legacy MRNs',
      icon: <Iconify icon="solar:users-group-rounded-bold" width={24} />
    },
    {
      value: 'profile',
      label: 'Profile',
      icon: <Iconify icon="solar:user-id-bold" width={24} />
    }
  ];

  return (
    <>
      <Card
        sx={{
          mb: 3,
          height: 290
        }}>
        <ProfileCover
          MRNLabel={
            props?.labels?.fields?.[1]?.label +
            ' ' +
            props?.values?.[props?.labels?.fields?.[1]?.data_column]
          }
          name={`${lastNames !== 'null' && lastNames}, ${firstNames !== 'null' && firstNames} ${middleNames !== 'null' && middleNames}`}
          avatarName={`${lastNames.charAt(0)}${firstNames.charAt(0)}`.toUpperCase()}
          // avatarUrl={
          //   props?.values?.[props?.labels?.fields?.[2]?.data_column]?.includes(
          //     'Female'
          //   )
          //     ? _mock.image.avatar(24)
          //     : _mock.image.avatar(14)
          // }
          avatarUrl={''}
          coverUrl={_userAbout.coverUrl}
          renderPersonalInfo={renderPersonalInfo}
        />

        <Tabs
          value={currentTab}
          onChange={handleChangeTab}
          sx={{
            width: 1,
            bottom: 0,
            zIndex: 9,
            position: 'absolute',
            bgcolor: 'background.paper',
            [`& .MuiTabs-flexContainer`]: {
              pr: {md: 3},
              justifyContent: {
                sm: 'center',
                md: 'flex-end'
              }
            }
          }}>
          {TABS.map(tab => (
            <Tab
              key={tab.value}
              value={tab.value}
              icon={tab.icon}
              label={tab.label}
            />
          ))}
        </Tabs>
      </Card>

      {currentTab === 'legacyMRNs' && <div />}

      {currentTab === 'profile' && renderProfileInfo()}
    </>
  );
};

export default ProfilePage;
